export interface User {
	nick: string
	privilege: string
	isSlim: boolean
	uuid: string
	isMFAEnabled: boolean
}

export enum UserActions {
	SIGN_IN = 'USER_ACTIONS_SIGN_IN',
	SIGN_OUT = 'USER_ACTIONS_SIGN_OUT',
	CHANGE_IS_MFA_ENABLED = 'USER_ACTIONS_CHANGE_IS_MFA_ENABLED'
}
